module.exports = __webpack_public_path__ + "static/media/colorfrag-sm-1.ff30a215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/union-square/colorfrag-sm-1.jpg
// module id = 4451
// module chunks = 15